import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const EquipmentMediumIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 50 50" fill="none" {...props}>
    <path
      d="M47.8336 20.5508H1.76038C1.51554 20.5508 1.28571 20.4329 1.14282 20.2342C0.999933 20.0354 0.961646 19.78 1.03981 19.548L3.93088 10.9516C4.03485 10.6421 4.32507 10.4336 4.65156 10.4336H44.9423C45.2688 10.4336 45.559 10.6421 45.663 10.9516L48.5544 19.548C48.6325 19.78 48.5942 20.0354 48.4513 20.2342C48.3083 20.4329 48.0783 20.5508 47.8336 20.5508ZM2.81856 19.0298H46.7754L44.3956 11.9545H5.19805L2.81856 19.0298Z"
      fill="currentColor"
    />

    <path
      d="M44.8895 45.8286H4.70185C4.28176 45.8286 3.94141 45.4881 3.94141 45.0681V19.7897C3.94141 19.3698 4.28176 19.0293 4.70185 19.0293H44.8895C45.3096 19.0293 45.6499 19.3698 45.6499 19.7897V45.068C45.6499 45.4881 45.3096 45.8286 44.8895 45.8286ZM5.4623 44.3076H44.1289V20.5503H5.4623V44.3076Z"
      fill="currentColor"
    />

    <path
      d="M47.0561 45.8295H2.54121C2.12111 45.8295 1.78076 45.489 1.78076 45.069C1.78076 44.6489 2.12111 44.3086 2.54121 44.3086H47.056C47.476 44.3086 47.8164 44.6491 47.8164 45.069C47.8165 45.489 47.4761 45.8295 47.0561 45.8295Z"
      fill="currentColor"
    />

    <path
      d="M15.8983 36.2169H8.06514C7.64504 36.2169 7.30469 35.8764 7.30469 35.4564V23.6687C7.30469 23.2487 7.64514 22.9082 8.06514 22.9082H15.8983C16.3184 22.9082 16.6587 23.2487 16.6587 23.6687V35.4564C16.6587 35.8764 16.3184 36.2169 15.8983 36.2169ZM8.82569 34.6959H15.1378V24.4292H8.82569V34.6959Z"
      fill="currentColor"
    />

    <path
      d="M41.5296 36.2169H33.6965C33.2764 36.2169 32.936 35.8764 32.936 35.4564V23.6687C32.936 23.2487 33.2764 22.9082 33.6965 22.9082H41.5296C41.9497 22.9082 42.2901 23.2487 42.2901 23.6687V35.4564C42.2901 35.8764 41.9497 36.2169 41.5296 36.2169ZM34.4569 34.6959H40.7691V24.4292H34.4569V34.6959Z"
      fill="currentColor"
    />

    <path
      d="M29.6648 45.8295H19.9305C19.5104 45.8295 19.1699 45.489 19.1699 45.069V31.3503C19.1699 30.9303 19.5104 30.5898 19.9305 30.5898H29.6648C30.0849 30.5898 30.4253 30.9303 30.4253 31.3503V45.069C30.4253 45.489 30.0849 45.8295 29.6648 45.8295ZM20.6909 44.3085H28.9043V32.1108H20.6909V44.3085Z"
      fill="currentColor"
    />

    <path
      d="M11.9816 36.2169C11.5615 36.2169 11.2212 35.8764 11.2212 35.4564V23.6687C11.2212 23.2487 11.5615 22.9082 11.9816 22.9082C12.4017 22.9082 12.7421 23.2487 12.7421 23.6687V35.4564C12.7422 35.8764 12.4017 36.2169 11.9816 36.2169Z"
      fill="currentColor"
    />

    <path
      d="M37.613 36.2169C37.1929 36.2169 36.8525 35.8764 36.8525 35.4564V23.6687C36.8525 23.2487 37.193 22.9082 37.613 22.9082C38.033 22.9082 38.3734 23.2487 38.3734 23.6687V35.4564C38.3734 35.8764 38.033 36.2169 37.613 36.2169Z"
      fill="currentColor"
    />

    <path
      d="M15.8983 30.3237H8.06514C7.64504 30.3237 7.30469 29.9833 7.30469 29.5633C7.30469 29.1432 7.64514 28.8027 8.06514 28.8027H15.8983C16.3184 28.8027 16.6587 29.1432 16.6587 29.5633C16.6587 29.9833 16.3184 30.3237 15.8983 30.3237Z"
      fill="currentColor"
    />

    <path
      d="M41.5296 30.3237H33.6965C33.2764 30.3237 32.936 29.9833 32.936 29.5633C32.936 29.1432 33.2764 28.8027 33.6965 28.8027H41.5296C41.9497 28.8027 42.2901 29.1432 42.2901 29.5633C42.2901 29.9833 41.9497 30.3237 41.5296 30.3237Z"
      fill="currentColor"
    />

    <path
      d="M27.3826 38.7527H22.2111C21.791 38.7527 21.4507 38.4123 21.4507 37.9923V33.8601C21.4507 33.44 21.791 33.0996 22.2111 33.0996H27.3826C27.8026 33.0996 28.143 33.4401 28.143 33.8601V37.9923C28.143 38.4123 27.8026 38.7527 27.3826 38.7527ZM22.9717 37.2317H26.6222V34.6205H22.9717V37.2317Z"
      fill="currentColor"
    />

    <path
      d="M15.0102 11.9544H9.02754C8.60755 11.9544 8.26709 11.614 8.26709 11.194V6.76045C8.26709 6.34046 8.60755 6 9.02754 6H15.0102C15.4302 6 15.7707 6.34046 15.7707 6.76045V11.194C15.7707 11.614 15.4302 11.9544 15.0102 11.9544ZM9.78799 10.4335H14.2498V7.521H9.78799V10.4335Z"
      fill="currentColor"
    />

    <path
      d="M15.8983 39.564H8.06514C7.64504 39.564 7.30469 39.2235 7.30469 38.8035C7.30469 38.3834 7.64514 38.043 8.06514 38.043H15.8983C16.3184 38.043 16.6587 38.3834 16.6587 38.8035C16.6587 39.2235 16.3184 39.564 15.8983 39.564Z"
      fill="currentColor"
    />

    <path
      d="M41.5296 39.564H33.6965C33.2764 39.564 32.936 39.2235 32.936 38.8035C32.936 38.3834 33.2764 38.043 33.6965 38.043H41.5296C41.9497 38.043 42.2901 38.3834 42.2901 38.8035C42.2901 39.2235 41.9497 39.564 41.5296 39.564Z"
      fill="currentColor"
    />
  </SvgIcon>
);
